import axios from "axios";
import { LiveStormApiResponse } from "vue-app/components/LiveStormEvents/LiveStormEvents.types";

export const getLiveStormEvents = async (): Promise<LiveStormApiResponse> => {
  const response = await axios.get<LiveStormApiResponse>("/livestorm/events");

  return response.data;
};
